import { MaskedLine, Reveal } from "@/components/motion";
import SEO from "@/components/SEO";
import { CONTACT } from "@/data/site";

const LegalShell = ({ title, children, testid, seoTitle, seoDescription }) => (
  <div data-testid={testid}>
    <SEO title={seoTitle || title} description={seoDescription} />
    <section className="border-b border-ink/10">
      <div className="mx-auto max-w-4xl px-4 pb-14 pt-24 sm:px-6 sm:pt-32 lg:px-8">
        <p className="kicker">Heavy Metal — Legal</p>
        <h1 className="mt-6 font-heading text-4xl font-black tracking-tighter sm:text-6xl">
          <MaskedLine delay={0.1}>{title}</MaskedLine>
        </h1>
      </div>
    </section>
    <section className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:px-8">
      <Reveal>
        <div className="space-y-10 text-base leading-relaxed text-ink/65 [&_h2]:font-heading [&_h2]:text-base [&_h2]:font-bold [&_h2]:uppercase [&_h2]:tracking-tight [&_h2]:text-ink [&_a]:font-medium [&_a]:text-acid [&_a]:underline [&_a]:underline-offset-4 [&_strong]:font-medium [&_strong]:text-ink">
          {children}
        </div>
      </Reveal>
    </section>
  </div>
);

export function TermeniPage() {
  return (
    <LegalShell
      title="Termeni și Condiții"
      testid="termeni-page"
      seoDescription="Termenii și condițiile de utilizare a site-ului HEAVY METAL — servicii de prelucrare a metalului și produse metalice la comandă, Buzău."
    >
      <p className="font-mono text-xs uppercase tracking-widest text-ink/45">Ultima actualizare: iulie 2026</p>
      <div>
        <h2>1. Informații generale</h2>
        <p className="mt-3">
          Acest site este operat de HEAVY METAL, cu sediul în {CONTACT.address}.
          Utilizarea site-ului implică acceptarea acestor termeni și condiții.
        </p>
      </div>
      <div>
        <h2>2. Servicii și produse</h2>
        <p className="mt-3">
          HEAVY METAL oferă servicii de prelucrare a metalului (debitare laser, îndoire
          abkant, vopsitorie în câmp electrostatic, sudură MIG/TIG/LASER) și produse
          metalice la comandă (mobilier, porți și garduri, terase, carporturi,
          balustrade, panouri decorative, structuri metalice, mobilier urban).
          Informațiile de pe site au caracter informativ și nu constituie ofertă
          contractuală fermă.
        </p>
      </div>
      <div>
        <h2>3. Ofertare și comenzi</h2>
        <p className="mt-3">
          Ofertele de preț se emit în scris, pe baza documentației tehnice furnizate de
          client, și sunt valabile 30 de zile. Comanda devine fermă după confirmarea
          scrisă a ofertei și, după caz, plata unui avans convenit.
        </p>
      </div>
      <div>
        <h2>4. Proprietate intelectuală</h2>
        <p className="mt-3">
          Conținutul site-ului (texte, imagini, logo, elemente grafice) aparține
          HEAVY METAL și nu poate fi reprodus fără acordul scris.
        </p>
      </div>
      <div>
        <h2>5. Limitarea răspunderii</h2>
        <p className="mt-3">
          Ne străduim să menținem informațiile actualizate, însă nu garantăm absența
          erorilor. Nu răspundem pentru daune rezultate din utilizarea informațiilor
          de pe site fără o confirmare prealabilă.
        </p>
      </div>
      <div>
        <h2>6. Contact</h2>
        <p className="mt-3">
          Pentru întrebări legate de acești termeni, ne poți contacta la{" "}
          <a href={CONTACT.phoneHref}>{CONTACT.phone}</a> sau la adresa {CONTACT.address}.
        </p>
      </div>
    </LegalShell>
  );
}

export function AnpcPage() {
  return (
    <LegalShell
      title="ANPC"
      testid="anpc-page"
      seoTitle="ANPC — Protecția Consumatorilor"
      seoDescription="Informații ANPC pentru clienții HEAVY METAL: soluționarea alternativă a litigiilor (SAL) și soluționarea online a litigiilor (SOL)."
    >
      <div>
        <h2>Protecția consumatorilor</h2>
        <p className="mt-3">
          Conform legislației în vigoare, consumatorii au dreptul de a apela la
          soluționarea alternativă a litigiilor (SAL) sau la soluționarea online a
          litigiilor (SOL) în cazul unor neînțelegeri cu comerciantul.
        </p>
      </div>
      <div>
        <h2>ANPC — SAL</h2>
        <p className="mt-3">
          Detalii despre procedura de soluționare alternativă a litigiilor găsiți pe
          site-ul Autorității Naționale pentru Protecția Consumatorilor:{" "}
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" data-testid="anpc-sal-link">
            anpc.ro/ce-este-sal
          </a>
        </p>
      </div>
      <div>
        <h2>ANPC — SOL</h2>
        <p className="mt-3">
          Platforma europeană de soluționare online a litigiilor este disponibilă la:{" "}
          <a href="https://anpc.ro/ce-este-sol/" target="_blank" rel="noopener noreferrer" data-testid="anpc-sol-link">
            anpc.ro/ce-este-sol
          </a>
        </p>
      </div>
      <div>
        <h2>Reclamații</h2>
        <p className="mt-3">
          Înainte de a apela la ANPC, te rugăm să ne contactezi direct la{" "}
          <a href={CONTACT.phoneHref}>{CONTACT.phone}</a> — suntem convinși că putem
          rezolva orice situație rapid și corect.
        </p>
      </div>
    </LegalShell>
  );
}

export function CookiesPage() {
  return (
    <LegalShell
      title="Politica Cookies"
      testid="cookies-page"
      seoDescription="Politica de utilizare a cookie-urilor pe site-ul HEAVY METAL: cookie-uri esențiale, funcționale și modul de gestionare a consimțământului."
    >
      <p className="font-mono text-xs uppercase tracking-widest text-ink/45">Ultima actualizare: iulie 2026</p>
      <div>
        <h2>Ce sunt cookie-urile</h2>
        <p className="mt-3">
          Cookie-urile sunt fișiere mici de text stocate pe dispozitivul tău atunci
          când vizitezi un site. Ele ajută site-ul să funcționeze corect și îți
          îmbunătățesc experiența de navigare.
        </p>
      </div>
      <div>
        <h2>Ce cookie-uri folosim</h2>
        <p className="mt-3">
          <strong>Cookie-uri esențiale</strong> — necesare pentru funcționarea
          site-ului (de exemplu, memorarea consimțământului tău și a temei alese).
          Acestea nu pot fi dezactivate.
        </p>
        <p className="mt-3">
          <strong>Cookie-uri funcționale</strong> — rețin preferințele tale, precum
          alegerea făcută în bannerul de consimțământ.
        </p>
      </div>
      <div>
        <h2>Cum îți gestionezi consimțământul</h2>
        <p className="mt-3">
          La prima vizită îți afișăm un banner prin care poți accepta toate cookie-urile
          sau doar pe cele esențiale. Îți poți schimba oricând preferințele ștergând
          datele de navigare din browser; bannerul va fi afișat din nou.
        </p>
      </div>
      <div>
        <h2>Contact</h2>
        <p className="mt-3">
          Pentru întrebări despre această politică, ne poți contacta la{" "}
          <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>.
        </p>
      </div>
    </LegalShell>
  );
}
